import React, { useState } from "react";
import { Colors } from "../../../Constants/colors";
import { ListTableCol } from "./listTableCol";
import { Pagination } from "../../pagination";
import { SkeletonLoader } from "../../loader/skeletonLoader";
import { CheckBox } from "../../input/CheckBox";
import { MoreOptionsMenu } from "../../MoreOptionMenu";
import "./listTable.css";

interface titles {
  titleName: string;
  colWidth?: string;
  key?: string;
  onClick?: () => unknown;
}
interface PaginationInterface {
  onPageChange: (pageNo: number) => unknown;
  totalPage: number;
}
interface Props {
  titles: Array<titles>;
  data: Array<any>;
  style?: Object;
  isDataLoading?: boolean;
  transformFn: (list: Array<any>) => Array<any>;
  pagination?: PaginationInterface;
  onSelect?: (data: any) => unknown;
  onRowClick?: ((data: any) => unknown) | null;
  moreOptons?: {
    onEdit?: (data: any) => unknown;
    onRemove?: (data: any) => unknown;
  };
}

// TODO -> Give this props a type to make it consistant
export const ListTable = ({
  titles = [],
  data = [],
  isDataLoading = false,
  transformFn,
  pagination,
  onSelect,
  onRowClick = null,
  moreOptons,
}: Props) => {
  const transformDatForTable = transformFn(data || []);
  const [selectedData, setSelectedData] = useState<any | null>(null);
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const setSelectedRow = (rowData: any) => {
    if (selectedData && rowData.id === selectedData.id) {
      setSelectedData(null);
    } else {
      setSelectedData(rowData);
    }
  };

  return (
    <div>
      <div className="container">
        <div
          style={{
            flex: 1,
          }}
        >
          <ListTableCol
            style={{
              backgroundColor: Colors.White,
              position: "relative",
            }}
          >
            {/*   THE WIDTH IS EQUAL TO THE RADIO BUTTON */}

            {onSelect ? <div style={{ width: "13px" }} /> : <></>}

            {titles.map((title, index) => {
              return (
                <div
                  key={index}
                  className="font-bold"
                  style={{
                    width: title.colWidth || "80px",

                    // marginRight: title.colWidth / 2 || 0,
                  }}
                >
                  {title.titleName}
                </div>
              );
            })}
          </ListTableCol>

          {isDataLoading ? (
            <SkeletonLoader />
          ) : (
            transformDatForTable.map((rowData: any, index: number) => {
              const bgColor =
                index % 2 === 0 ? Colors.VeryLightGrey : Colors.DarkOffWhite;

              const needsColorChangeOnHover =
                onRowClick && hoveredIndex === index;
              const hoverColor = needsColorChangeOnHover
                ? Colors.Midgrey
                : undefined;

              return (
                <div
                  onClick={() => {
                    onRowClick && onRowClick(rowData);
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                >
                  <ListTableCol
                    style={{
                      backgroundColor: hoverColor || bgColor,
                      color: needsColorChangeOnHover
                        ? Colors.White
                        : Colors.DarkGrey,
                      position: "relative",
                      cursor: onRowClick ? "pointer" : undefined,
                    }}
                    key={`${index}`}
                  >
                    {onSelect ? (
                      <div>
                        <CheckBox
                          isChecked={rowData.id === (selectedData?.id || "")}
                          setIsChecked={() => {
                            setSelectedRow(rowData);
                            onSelect(rowData);
                          }}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    {titles.map((title, index) => {
                      return (
                        <div
                          className="font-medium"
                          style={{
                            width: title.colWidth || "80px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            gap: "50px",
                          }}
                          onClick={title.onClick}
                        >
                          {rowData[title.key || title.titleName] || ""}
                          {/* For some cases titleName will just be fine as it matches the key name of JSON value */}
                        </div>
                      );
                    })}

                    {!!moreOptons ? (
                      <div
                        style={{
                          position: "absolute",
                          right: 20,
                        }}
                      >
                        <MoreOptionsMenu
                          onEdit={
                            moreOptons.onEdit
                              ? () =>
                                  moreOptons.onEdit &&
                                  moreOptons.onEdit(rowData)
                              : undefined
                          }
                          onRemove={
                            moreOptons.onRemove
                              ? () =>
                                  moreOptons.onRemove &&
                                  moreOptons.onRemove(rowData)
                              : undefined
                          }
                        />
                      </div>
                    ) : (
                      <div />
                    )}
                  </ListTableCol>
                </div>
              );
            })
          )}
        </div>
      </div>
      {!!pagination && pagination?.totalPage > 1 ? (
        <div className="w-full flex justify-center">
          <Pagination
            totalPage={pagination.totalPage}
            onPageChange={pagination.onPageChange}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
